import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=ba758d04&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=ba758d04&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba758d04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba758d04')) {
      api.createRecord('ba758d04', component.options)
    } else {
      api.reload('ba758d04', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=ba758d04&scoped=true&", function () {
      api.rerender('ba758d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2OOriInJpH0Xz/JS/comp/Paginate.vue"
export default component.exports